import { apiSlice } from '../api-slice';
import { signInSuccess } from './session-slice';
import { setUser } from './user-slice';
import { UserSchema } from './user.schema';

export const sessionApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        register: builder.mutation({
            query: (data) => ({
                url: 'register',
                method: 'POST',
                body: data,
            }),
        }),
        login: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/login',
                    method: 'POST',
                    body: data,
                };
            },
            async onQueryStarted(_arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

                    dispatch(
                        signInSuccess({
                            accessToken: result.data.data.access_token,
                            refreshToken: result.data.data.refresh_token,
                        }),
                    );
                    localStorage.setItem(
                        'auth',
                        JSON.stringify({
                            accessToken: result.data.data.access_token,
                            refreshToken: result.data.data.refresh_token,
                        }),
                    );
                } catch (error) {
                    console.error(error);
                }
            },
        }),

        logout: builder.mutation<{ message: string }, void>({
            query: () => ({
                url: 'auth/logout',
                method: 'POST',
            }),
        }),

        verifyToken: builder.query({
            query: () => `/auth/verify-token`,
            providesTags: ['Auth_User'],

            async onQueryStarted(_arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

                    const validatedResult = UserSchema.safeParse(
                        result?.data?.data,
                    );

                    if (validatedResult.success) {
                        dispatch(setUser(validatedResult.data));
                    }
                } catch (error) {
                    console.error(error);
                }
            },
        }),
    }),
});

export const {
    useLoginMutation,
    useLogoutMutation,
    useRegisterMutation,
    useVerifyTokenQuery,
} = sessionApi;
